"use strict";
exports.__esModule = true;
exports.toChartsSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var toChart = function (data, logger) {
    var image = logger.required(fields_1.toImage(data.chart, logger));
    var transcription = logger.required(fields_1.toRichText(data.transcription, logger));
    if (!image || !transcription) {
        return undefined;
    }
    return {
        image: image,
        transcription: transcription
    };
};
var toChartsSlice = function (data, logger) {
    var charts = data === null || data === void 0 ? void 0 : data.items.map(function (item) { return toChart(item, logger); }).filter(Boolean);
    if ((charts === null || charts === void 0 ? void 0 : charts.length) === 0) {
        return undefined;
    }
    return utils_1.compact({
        type: types_1.SliceType.Charts,
        charts: charts
    });
};
exports.toChartsSlice = toChartsSlice;
//# sourceMappingURL=charts-slice.js.map